import { faPlus } from '@fortawesome/pro-solid-svg-icons';
import { yupResolver } from '@hookform/resolvers/yup';
import { Button, Modal, ModalCloseButton, ModalDescription, ModalFooter, ModalHeader, NotificationDispatch, TextField } from '@tryhackme/thm-ui-components';
import { useState } from 'react';
import { useForm } from 'src/common/form';
import { isQueryErrorWithMessage } from 'src/common/helpers/slices';
import { useAddInstructorMutation } from '../../corporate.slice';
import { StyledAddIcon } from '../../corporate.styles';
import type { CreateInstructorProps, InstructorModalProps } from '../../corporate.types';
import { addInstructorsValidationSchema } from './add-instructor-modal.constant';
import { StyledButton, StyledModalTitle } from './add-instructor-modal.styles';
export const AddInstructorModal = ({
  width,
  companyId
}: InstructorModalProps) => {
  const [addInstructor] = useAddInstructorMutation();
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const handleModalClose = () => {
    setModalOpen(false);
  };
  const {
    register,
    getValues,
    reset,
    handleSubmit,
    formState: {
      errors
    }
  } = useForm<CreateInstructorProps>({
    defaultValues: {
      companyId: '',
      emails: ''
    },
    mode: 'onChange',
    resolver: yupResolver(addInstructorsValidationSchema)
  });
  const onSubmit = async () => {
    try {
      const {
        emails
      }: CreateInstructorProps = getValues();
      const adminEmails: string[] = emails.split(',').map((email: string) => email.trim());
      await addInstructor({
        companyId,
        adminEmails
      }).unwrap();
      NotificationDispatch('success', 'Admin/s added successfully');
    } catch (error) {
      NotificationDispatch('error', isQueryErrorWithMessage(error) ? error.data.message : 'An unknown error has occurred');
    }
    reset();
    handleModalClose();
  };
  return <Modal onOpenChange={open => {
    setModalOpen(open);
    reset();
  }} open={modalOpen} triggerElement={<StyledButton color="secondary" variant="outlined" width={width}>
          <StyledAddIcon icon={faPlus} /> Add admin
        </StyledButton>} isSmall data-sentry-element="Modal" data-sentry-component="AddInstructorModal" data-sentry-source-file="add-instructor-modal.tsx">
      <ModalHeader isSmall data-sentry-element="ModalHeader" data-sentry-source-file="add-instructor-modal.tsx">
        <StyledModalTitle isSmall data-sentry-element="StyledModalTitle" data-sentry-source-file="add-instructor-modal.tsx">Add admins</StyledModalTitle>
      </ModalHeader>
      <ModalDescription data-sentry-element="ModalDescription" data-sentry-source-file="add-instructor-modal.tsx">Copy & paste all emails in the box below separated by a comma or a space.</ModalDescription>
      {/* eslint-disable-next-line @typescript-eslint/no-misused-promises */}
      <form id="add-users" method="dialog" onSubmit={handleSubmit(onSubmit)}>
        <TextField {...register('emails')} id="email-id" label="Admins' email addresses" placeholder="example1@thm.com, example2@thm.com, example3@thm.com" rows={4} variant="textarea" isError={!!errors.emails?.message} errorMessage={errors.emails?.message} data-sentry-element="TextField" data-sentry-source-file="add-instructor-modal.tsx" />
        <ModalFooter isSmall data-sentry-element="ModalFooter" data-sentry-source-file="add-instructor-modal.tsx">
          <ModalCloseButton text="Cancel" handleCloseButtonAction={() => reset()} data-sentry-element="ModalCloseButton" data-sentry-source-file="add-instructor-modal.tsx" />
          <Button type="submit" color="primary" variant="solid" data-sentry-element="Button" data-sentry-source-file="add-instructor-modal.tsx">
            Add admins
          </Button>
        </ModalFooter>
      </form>
    </Modal>;
};